<template>
    <div>
        <div v-if="!id">
            <div class="text-center text-muted">

            </div>
        </div>
        <div v-else>
            <!-- Loading -->
            <b-overlay :show="form.busy || loading">
                <!-- Form -->
                <form @submit.prevent="submit" novalidate="true">

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Name')">
                        <b-form-input
                            v-model="form.name"
                            :class="{ 'is-invalid': form.errors.has('name') }"
                        ></b-form-input>
                        <has-error :form="form" field="name"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Sport')">
                        <select v-model="form.fk_sport" class="custom-select" :class="{ 'is-invalid': form.errors.has('fk_sport') }">
                            <option v-for="sport in sports" :key="sport.id" :value="sport.id">{{ sport.name }}</option>
                        </select>
                        <has-error :form="form" field="fk_sport"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Description')">
                        <b-form-textarea
                            rows="3"
                            v-model="form.description"
                            :class="{ 'is-invalid': form.errors.has('description') }"
                        ></b-form-textarea>
                        <has-error :form="form" field="description"></has-error>
                    </b-form-group>

                    <div class="d-flex align-content-center justify-content-between">
                        <!-- Submit -->
                        <b-button type="submit" variant="primary" :disabled="form.busy">
                            {{ __('configuration.Save') }}
                        </b-button>

                        <!-- Destroy -->
                        <b-button type="button" variant="outline-danger" @click="destroy">
                            {{ __('configuration.Delete Strategy') }}
                        </b-button>
                    </div>

                </form>
            </b-overlay>
        </div>

    </div>
</template>

<script>
import { Form } from "vform";

export default {
    props: ['locale', 'currency'],
    data() {
        return {
            id: null,
            loading: false,
            form: new Form({
                name: null,
                description: null,
                fk_sport: null,
            }),
            formDestroy: new Form({
                password: null,
            }),
            sports: [],
            strategySportSelect: null
        }
    },
    created() {
        this.$root.$on('editStrategy', (strategy) => {
            this.strategySportSelect = strategy.fk_sport;
            this.loadSports();
            this.id = strategy.id
            this.form = new Form({
                name: strategy.name,
                description: strategy.description,
                fk_sport: strategy.fk_sport,
            })
        })
    },
    methods: {

        loadSports() {
            this.loading = true
            axios.get('/sports/select')
                .then((result) => {
                    this.sports = result
                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.form.put('/' + this.locale + '/configurations/strategies/' + this.id)
                .then(result => {

                    this.$toast.success(result.message)

                    if (this.strategySportSelect !== this.form.fk_sport) {
                        this.id = false;
                    }

                    this.$emit('updated')
                })
        },

        destroy() {
            this.$bvModal.msgBoxConfirm(this.__('configuration.Please confirm that you want to delete'), {
                title: this.__('configuration.Delete Strategy'),
                okVariant: 'danger',
                okTitle: this.__('configuration.Yes'),
                cancelTitle: this.__('configuration.No'),
                footerClass: 'p-2',
                hideHeaderClose: true,
            })
                .then((value) => {
                    if (value) {
                        this.loading = true
                        axios.delete('/' + this.locale + '/configurations/strategies/' + this.id)
                            .then((result) => {
                                this.$emit('updated')
                                this.id = false;
                                this.$toast.success(result.message)
                            })
                            .finally(() => this.loading = false)
                    }
                })
        }
    }
}
</script>

<style scoped>

</style>
